import ApiError from '@/models/entities/api/api-error';
import ApiAlreadyHandled from '@/models/entities/api/api-already-handled';
import ApiResponse from '@/models/entities/api/api-response';
import ApiLocked from '@/models/entities/api/api-locked';
import { API_RESULT_TYPE, ApiResultType } from '@/models/entities/api/api-result-type';

interface ApiResultMap<T extends ApiResponse> {
  [API_RESULT_TYPE.RESPONSE]: T;
  [API_RESULT_TYPE.ERROR]: ApiError;
  [API_RESULT_TYPE.ALREADY_HANDLED]: ApiAlreadyHandled;
  [API_RESULT_TYPE.LOCKED]: ApiLocked;
}

export type AnyApiResult<T extends ApiResponse> = ApiResultMap<T>[ApiResultType];
export type ProtectedApiResult<T extends ApiResponse> =
  | ApiResultMap<T>[typeof API_RESULT_TYPE.RESPONSE]
  | ApiResultMap<T>[typeof API_RESULT_TYPE.ERROR]
  | ApiResultMap<T>[typeof API_RESULT_TYPE.ALREADY_HANDLED];

export function isResponse<T extends ApiResponse>(result: AnyApiResult<T>): result is T {
  return result.apiResultType === API_RESULT_TYPE.RESPONSE;
}

export function isError<T extends ApiResponse>(result: AnyApiResult<T>): result is ApiError {
  return result.apiResultType === API_RESULT_TYPE.ERROR;
}

export function isAlreadyHandled<T extends ApiResponse>(
  result: AnyApiResult<T>,
): result is ApiAlreadyHandled {
  return result.apiResultType === API_RESULT_TYPE.ALREADY_HANDLED;
}

export function isLocked<T extends ApiResponse>(result: AnyApiResult<T>): result is ApiLocked {
  return result.apiResultType === API_RESULT_TYPE.LOCKED;
}
